import {
  GETWAYTRANSACTIONLIST_SUCCESS,
  GETWAYTRANSACTIONLIST_FAILED,
  RESET_GETWAYTRANSACTIONLIST,
  LOADING_GETWAYTRANSACTIONLIST,
  NETWORK_ERROR_GETWAYTRANSACTIONLIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetWayTransactionList = () => {
  return { type: RESET_GETWAYTRANSACTIONLIST };
};

const getWayTransactionList = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_GETWAYTRANSACTIONLIST });
  await partnerServices
    .post("getWayTransactionList", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.data.status) {
        case "success":
          dispatch(getWayTransactionListsuccess(res.data));
          break;
        default:
          dispatch(getWayTransactionListFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({ type: NETWORK_ERROR_GETWAYTRANSACTIONLIST, payload: err });
    });
};
function getWayTransactionListsuccess(data) {
  return {
    type: GETWAYTRANSACTIONLIST_SUCCESS,
    payload: data,
  };
}
function getWayTransactionListFailed(data) {
  return {
    type: GETWAYTRANSACTIONLIST_FAILED,
    payload: data,
  };
}

export { resetGetWayTransactionList, getWayTransactionList };
